import { useState } from 'react'
import Flex from './utils/Flex'
import TWInput from './utils/TWInput/TWInput'
import TWButton from './utils/TWButton/TWButton'
import IconClose from './icons/IconClose'
import Icon from './utils/Icon'

const CreateSubscription = ({ onCreate, onCancel }) => {

	const [subs, setSubs] = useState({
		1: '', 3: '', 6: '', 12: '',
	})

	const onSubmit = e => {
		e.preventDefault()
		let subscription = Object.values(subs).find(value => !!value)
		if (subscription && onCreate) onCreate(subscription)
	}

	return (
		<div className="createsubs relative p-3 lg:p-16">
			<Icon onClick={() => onCancel()} className='absolute top-4 right-4 w-5 h-5 cursor-pointer'>
				<IconClose />
			</Icon>
			<h4 className="text-xl lg:text-2xl xl:text-3xl font-bold">
				Create Subscription
			</h4>
			<p className="text-sm xl:text-lg text-gray-300">
				Enter the amount you wish to charge for the subscription prices.
			</p>
			<form onSubmit={onSubmit} className="mt-4 lg:mt-8">
				<TWInput
					name="one-month"
					label="1 Month"
					v-model="subs[1]"
					value={subs[1]}
					onChange={v => setSubs({ ...subs, 1: v })}
					hint="$13.99"
					dark
					labelClass="w-28"
					className="mb-1 md:mb-6"
					inputClass="w-full"
					contentClass="w-full"
					helpText='<span className="text-yellow-500">+ Add Promotional Sale</span>'
				/>
				<TWInput
					name="three-month"
					label="3 Months"
					value={subs[3]}
					onChange={v => setSubs({ ...subs, 3: v })}
					hint="$41.97"
					dark
					labelClass="w-28"
					className="mb-1 md:mb-6"
					inputClass="w-full"
					contentClass="w-full"
					helpText="Current Discounted Price 0%"
				/>
				<TWInput
					name="six-month"
					label="6 Months"
					value={subs[6]}
					onChange={v => setSubs({ ...subs, 6: v })}
					hint="$83.94"
					dark
					labelClass="w-28"
					className="mb-1 md:mb-6"
					inputClass="w-full"
					contentClass="w-full"
					helpText="Current Discounted Price 0%"
				/>
				<TWInput
					name="twelve-month"
					label="12 Months"
					value={subs[12]}
					onChange={v => setSubs({ ...subs, 12: v })}
					hint="$167.88"
					dark
					labelClass="w-28"
					className="mb-1 md:mb-6"
					inputClass="w-full"
					contentClass="w-full"
					helpText="Current Discounted Price 0%"
				/>
				<div className="text-center text-gray-300">
					<span className="text-blue-300">Note:</span> People are more likely to
					subscribe with discounted bundles
				</div>
				<Flex justify-between className="mt-10 space-x-12">
					<TWButton size="sm" color="primary" >Create</TWButton>
					<TWButton size="sm" onClick={() => onCancel && onCancel()}>
						Cancel
					</TWButton>
				</Flex>
			</form>
		</div>
	)
}

export default CreateSubscription